import { create } from '@bufbuild/protobuf';

import * as pbm from '@/grpc-gen/campaign_pb';
import * as pbs from '@/grpc-gen/settings_service_pb';
import ApiCampaign from '@/model/Campaign';

export default class Campaign extends ApiCampaign {
  static fromGrpcResponse(r: pbs.CampaignResponse): Campaign {
    return Campaign.fromGrpcModel(r.campaign);
  }

  static fromGrpcModel(o?: pbm.Campaign): Campaign {
    const e = new Campaign();

    e.id = Number(o?.id ?? 0);
    e.subdomain = o?.subdomain ?? '';
    e.description = o?.description ?? '';

    return e;
  }

  toGrpcModel(): pbm.Campaign {
    return create(pbm.CampaignSchema, {
      id: BigInt(this.id),
      subdomain: this.subdomain ?? '',
      description: this.description ?? '',
    });
  }
}
